import { render, staticRenderFns } from "./RentCarTickets.vue?vue&type=template&id=1c01d50a"
import script from "./RentCarTickets.vue?vue&type=script&lang=js"
export * from "./RentCarTickets.vue?vue&type=script&lang=js"
import style0 from "./RentCarTickets.vue?vue&type=style&index=0&id=1c01d50a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports